<template>
  <LoginTemplate />
</template>

<script lang="js">
import LoginTemplate from '@/components/template/login/index.vue'

export default {
  name: 'LoginTemplatePage',
  components: {
    LoginTemplate,
  }
}
</script>
<style lang="scss">
</style>